export const config = {
  AI_WIN_REWARD: 10000,
  PLAYER_WIN_PUNISHMENT: -10000,
  numRows: 6,
  numColsSmall: 5,
  numColsBig: 7,
  winCount: 4,
  PLAYERS: 2,
  difficultyToMaxDepth: {
    1: 0,
    2: 1,
    3: 5,
  },
};
